import { Component, Input } from '@angular/core';
import { NoSwellDataText } from 'src/app/models/app-constants';
@Component({
	selector: 'app-swell-forecast',
	templateUrl: './swell-forecast.component.html',
	styleUrls: ['./swell-forecast.component.scss']
})
export class SwellForecastComponent {
	@Input() swellHeight : number | undefined;
	@Input() swellDirection : string | undefined;

	public noSwellData: string = NoSwellDataText;
	public swellData_: boolean = true;

	ngOnInit(): void {
		if (this.swellHeight == null || this.swellDirection == null){
			this.swellData_ = false
		}
		
	}
}	
